import { ISubscriptionForm } from './types';

export const mapSubscriptionForm = ({ prismicContent }): ISubscriptionForm => {
  const {
    below_button_text: belowButtonText,
    button_label: buttonLabel,
    cb_above_button_text: cbAboveButtonText,
    change_payment_method_label: changePaymentMethodLabel,
    iban_above_button_text: ibanAboveButtonText,
    payment_method_selected_text: paymentMethodSelectedText,
    payment_method_selected_text_checkout: paymentMethodSelectedTextCheckout,
    payment_method_selected_title: paymentMethodSelectedTitle,
    secured_payment_with_locker: securedPaymentWithLocker,
    select_payment_method_text: selectPaymentMethodText,
    select_payment_method_text_checkout: selectPaymentMethodTextCheckout,
    select_payment_method_title: selectPaymentMethodTitle,

    coupon_form_headings,
    is_coupon_form_displayed: isCouponFormDisplayed,
    coupon_link_button: couponLinkButton,
    coupon_input_placeholder: couponInputPlaceholder,
    coupon_button: couponButton,
    coupon_error: couponError,
    coupon_success: couponSuccess,
  } = prismicContent.primary;

  const SubscriptionForm: ISubscriptionForm = {
    ...prismicContent.primary,
    selectPaymentMethodTitle,
    selectPaymentMethodText,
    selectPaymentMethodTextCheckout,
    paymentMethodSelectedTitle,
    paymentMethodSelectedText,
    paymentMethodSelectedTextCheckout,
    changePaymentMethodLabel,
    securedPaymentWithLocker,
    cbAboveButtonText,
    ibanAboveButtonText,
    buttonLabel,
    belowButtonText,

    couponFormHeadings: coupon_form_headings,
    isCouponFormDisplayed,
    couponButton,
    couponLinkButton,
    couponInputPlaceholder,
    couponError,
    couponSuccess,
  };

  return SubscriptionForm;
};
